<template>
    <div class="individual-tariff__container" id="individual__title">
        <span class="individual-tariff__title">{{ $t("lang.pages.tariff.individualTariff.title") }}</span>
        <span class="individual-tariff__description">{{ $t("lang.pages.tariff.individualTariff.description") }}</span>
        <div class="individual-tariff__button_container">
            <a href="#" id="individual-tariff__button" @click.prevent class="individual-tariff__button">
                {{ $t("lang.pages.tariff.individualTariff.button") }}
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: "TariffPageIndividualTariff",
    props: {
        locale: String
    }
}
</script>

<style scoped>
.individual-tariff__container {
    display: flex;
    flex-direction: column;
    text-align: center;
    max-width: 600px;
    margin: 0 auto 80px;
}
.individual-tariff__title {
    display: inline-block;
    font-size: 36px;
    line-height: 40px;
    margin-bottom: 4px;
}
.individual-tariff__description {
    display: inline-block;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 12px;
}
.individual-tariff__button {
    display: inline-block;
    padding: 12px 85px;
    background-color: #70B319;
    border-radius: 4px;
    text-decoration: none;
    color: #fff;
}
/* отступ сверху при переходе с якорем на индивидуальный тарифный план */
#individual__title:target {
  scroll-margin-top: 140px;
}
</style>
